import { Injectable, Injector } from '@angular/core';
import { AnchorsApiService } from './anchors-api.service';
import { AuthApiService } from './auth-api.service';
import { CatalogApiService } from './catalog-api.service';
import { SimApiService } from './sim-api.service';
import { AgreementsApiService } from './agreements-api.service';
import { ProductSelectorApiService } from './product-selector-api.service';
import { NetworkGuaranteeApiService } from './network-guarantee-api.service';
import { GeographicAddressMgtApiService } from './geographic-address-mgt-api.service';
import { ProductActivationApiService } from './product-activation-api.service';
import { OtpSnowApiService } from './otp-snow-api.service';
import { NewsApiService } from './news-api.service';
import { NotificationsApiService } from './notifications-api.service';
import { WorkflowApiService } from './workflow-api.service';
import { ChangeApiService } from './change-api.service';
import { SessionApiService } from '../session/session-api.service';
import { DashboardApiService } from './dashboard-api.service';
import { NewsCategoriesApiService } from './news-categories-api.service';
import { NumbersApiService } from './numbers-api.service';
import { NewsNotificationsApiService } from './news-notifications-api.service';

@Injectable({
  providedIn: 'root',
  deps: [Injector]
})
export class ApiService {
  private authApiService: AuthApiService;
  private simApiService: SimApiService;
  private anchorsApiService: AnchorsApiService;
  private catalogApiService: CatalogApiService;
  private agreementsApiService: AgreementsApiService;
  private productSelectorApiService: ProductSelectorApiService;
  private networkGuaranteeApiService: NetworkGuaranteeApiService;
  private geographicAddressMgtApiService: GeographicAddressMgtApiService;
  private productActivationApiService: ProductActivationApiService;
  private otpSnowApiService: OtpSnowApiService;
  private workflowApiService: WorkflowApiService;
  private newsApiService: NewsApiService;
  private notificationsApiService: NotificationsApiService;
  private changeApiService: ChangeApiService;
  private sessionApiService: SessionApiService;
  private dashboardApiService: DashboardApiService;
  private newsCategoriesApiService: NewsCategoriesApiService;
  private numbersApiService: NumbersApiService;
  private newsNotificationsApiService: NewsNotificationsApiService;

  constructor(private injector: Injector) { }


  public get categories(): NewsCategoriesApiService{
    if (!this.newsCategoriesApiService) {
      this.newsCategoriesApiService = this.injector.get(NewsCategoriesApiService);
    }
    return this.newsCategoriesApiService;
  }

  public get numbers(): NumbersApiService {
    if (!this.numbersApiService) {
      this.numbersApiService = this.injector.get(NumbersApiService);
    }
    return this.numbersApiService;
  }
  public get newsNotification(): NewsNotificationsApiService {
    if (!this.newsNotificationsApiService) {
      this.newsNotificationsApiService = this.injector.get(NewsNotificationsApiService);
    }
    return this.newsNotificationsApiService;
  }

  public get auth(): AuthApiService {
    if (!this.authApiService) {
      this.authApiService = this.injector.get(AuthApiService);
    }

    return this.authApiService;
  }

  public get catalog(): CatalogApiService {
    if (!this.catalogApiService) {
      this.catalogApiService = this.injector.get(CatalogApiService);
    }

    return this.catalogApiService;
  }

  public get dashboard(): DashboardApiService {
    if (!this.dashboardApiService) {
      this.dashboardApiService = this.injector.get(DashboardApiService);
    }
    return this.dashboardApiService;
  }

  public get sim(): SimApiService {
    if (!this.simApiService) {
      this.simApiService = this.injector.get(SimApiService);
    }

    return this.simApiService;
  }

  public get anchors(): AnchorsApiService {
    if (!this.anchorsApiService) {
      this.anchorsApiService = this.injector.get(AnchorsApiService);
    }

    return this.anchorsApiService;
  }

  public get agreements(): AgreementsApiService {
    if (!this.agreementsApiService) {
      this.agreementsApiService = this.injector.get(AgreementsApiService);
    }

    return this.agreementsApiService;
  }

  public get productSelector(): ProductSelectorApiService {
    if (!this.productSelectorApiService) {
      this.productSelectorApiService = this.injector.get(ProductSelectorApiService);
    }

    return this.productSelectorApiService;
  }

  public get networkGuarantee(): NetworkGuaranteeApiService {
    if (!this.networkGuaranteeApiService) {
      this.networkGuaranteeApiService = this.injector.get(NetworkGuaranteeApiService);
    }

    return this.networkGuaranteeApiService;
  }

  public get geographicAddressMgt(): GeographicAddressMgtApiService {
    if (!this.geographicAddressMgtApiService) {
      this.geographicAddressMgtApiService = this.injector.get(GeographicAddressMgtApiService);
    }

    return this.geographicAddressMgtApiService;
  }

  public get productActivation(): ProductActivationApiService {
    if (!this.productActivationApiService) {
      this.productActivationApiService = this.injector.get(ProductActivationApiService);
    }

    return this.productActivationApiService;
  }

  public get otpSnow(): OtpSnowApiService {
    if (!this.otpSnowApiService) {
      this.otpSnowApiService = this.injector.get(OtpSnowApiService);
    }

    return this.otpSnowApiService;
  }

  public get news(): NewsApiService {
    if (!this.newsApiService) {
      this.newsApiService = this.injector.get(NewsApiService);
    }

    return this.newsApiService;
  }

  public get notifications(): NotificationsApiService {
    if (!this.notificationsApiService) {
      this.notificationsApiService = this.injector.get(NotificationsApiService);
    }

    return this.notificationsApiService;
  }

  public get workflow(): WorkflowApiService {
    if (!this.workflowApiService) {
      this.workflowApiService = this.injector.get(WorkflowApiService);
    }

    return this.workflowApiService;
  }

  public get simChange(): ChangeApiService {
    if (!this.changeApiService) {
      this.changeApiService = this.injector.get(ChangeApiService);
    }

    return this.changeApiService;
  }

  public get session(): SessionApiService {
    if (!this.sessionApiService) {
      this.sessionApiService = this.injector.get(SessionApiService);
    }

    return this.sessionApiService;
  }
}
